// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CrisisAttachedFileInfo_abstract } from './../abstract/SagaSchema/CrisisAttachedFileInfo_abstract';
export class CrisisAttachedFileInfo extends CrisisAttachedFileInfo_abstract {}
